const findNameData = (masterData, paramsTitle, paramsId) => {
    const resItem = masterData[paramsTitle].find((item) => item.id === paramsId);
    return resItem ? resItem.name : "";
};

export default findNameData